export const usePageLoading = () => {
  const nuxtApp = useNuxtApp()
  
  // Get the page loading state from the app context
  const isLoading = computed(() => {
    const pageLoading = nuxtApp.$pageLoading as Ref<boolean> | undefined
    return pageLoading?.value || false
  })
  
  // Provide immediate loading feedback
  const setLoading = (loading: boolean) => {
    const pageLoading = nuxtApp.$pageLoading as Ref<boolean> | undefined
    if (pageLoading) {
      pageLoading.value = loading
    }
  }
  
  return {
    isLoading,
    setLoading
  }
} 